import { BackgroundColor } from '@ampcore/ampcom-contracts'
import React, { forwardRef } from 'react'

import { rteContentFilter } from '../../lib/helpers/rteContentFilter'
import { TestimonialCardProps } from './TestimonialCard.type'
import type { TestimonialCardBackgroundColor } from './TestimonialColor.type'

export const TestimonialCard = forwardRef<HTMLDivElement, TestimonialCardProps>(
  (props, ref) => {
    const {
      testimonialStatement,
      personImage,
      personInfo,
      backgroundColor,
      variant
    } = props

    const trimmedPersomImg = personImage.trim()

    const getBackgroundColor = (color: TestimonialCardBackgroundColor) => {
      switch (color) {
        case BackgroundColor.STONE:
          return 'u-bgColorStone'
        case BackgroundColor.PURPLE_TINT:
          return 'u-bgColorPurpleLight10'
        case BackgroundColor.LIME_TINT:
          return 'u-bgColorLimeLight20'
        case BackgroundColor.MINT_TINT:
          return 'u-bgColorMintLight10'
        case BackgroundColor.ORANGE_TINT:
          return 'u-bgColorOrangeLight20'
        case BackgroundColor.BERRY_TINT:
          return 'u-bgColorBerryLight10'
        default:
          return 'u-bgColorWhite'
      }
    }

    return (
      <blockquote
        className={`TestimonialCard u-sizeFull u-paddingHoriz32 u-sm-paddingVert24 u-posRelative ${getBackgroundColor(
          backgroundColor || BackgroundColor.WHITE
        )} ${
          variant === 'single-bubble'
            ? 'u-lg-flex u-lg-flexAlignItemsCenter u-paddingVert32'
            : 'u-paddingVert24'
        }`}
      >
        {variant === 'single-bubble' && personImage && (
          <cite className="TestimonialCard-avatar TestimonialCard-avatar--big u-marginRight32 u-md-hidden u-sm-hidden">
            <figure className="image-block">
              <img src={trimmedPersomImg} alt="" />
            </figure>
          </cite>
        )}
        <div>
          {testimonialStatement && (
            <div className="TestimonialCard-textContainer u-paddingBottom24">
              <div
                className="Content content-block"
                dangerouslySetInnerHTML={{
                  __html: rteContentFilter(testimonialStatement ?? '')
                }}
                data-testid={props.testId ? `${props.testId}-statement` : null}
                ref={ref}
              ></div>
            </div>
          )}
          <footer className="TestimonialCard-footer u-bgColorTransparent u-paddingTop20 u-flex u-flexAlignItemsCenter">
            {personImage && (
              <cite
                className={`TestimonialCard-avatar u-marginRight20 ${
                  variant === 'single-bubble' ? 'u-lg-hidden' : ''
                }`}
              >
                <figure className="image-block">
                  <img src={trimmedPersomImg} alt="" />
                </figure>
              </cite>
            )}
            {personInfo && (
              <cite>
                <div
                  className="Content content-block"
                  dangerouslySetInnerHTML={{
                    __html: rteContentFilter(personInfo ?? '')
                  }}
                  data-testid={
                    props.testId ? `${props.testId}-personinfo` : null
                  }
                ></div>
              </cite>
            )}
          </footer>
          <div
            aria-hidden="true"
            className={`TestimonialCard-notch ${getBackgroundColor(
              backgroundColor || BackgroundColor.WHITE
            )}`}
          ></div>
        </div>
      </blockquote>
    )
  }
)
